import './Sidebar.scss'
import { Link, NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faUserAstronaut, faContactCard, faComputer, faProjectDiagram, faCode, faFileLines } from '@fortawesome/free-solid-svg-icons'
import {
   faLinkedin,
   faGithub,
} from '@fortawesome/free-brands-svg-icons'
import { profile, sidebarMark } from '../../data/profileData'

function Sidebar() {
   return (
     <div className="nav-bar">
       <Link className="logo" to="/">
         <img src={sidebarMark} alt="Sameer" />
         <div className="sidebar-name">Sameer</div>
       <div className="sidebar-role">AI Systems Engineer</div>
       </Link>
       <nav>
         <div className="nav-item">
           <NavLink exact="true" activeclassname="active" to="/">
             <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
           </NavLink>
           <div className="horizontal-line" />
         </div>
         <div className="nav-item">
           <NavLink activeclassname="active" className="about-link" to="/about">
             <FontAwesomeIcon icon={faUserAstronaut} color="#4d4d4e" />
           </NavLink>
           <div className="horizontal-line" />
         </div>
         <div className="nav-item">
           <NavLink activeclassname="active" className="skill-link" to="/skill">
             <FontAwesomeIcon icon={faComputer} color="#4d4d4e" />
           </NavLink>
           <div className="horizontal-line" />
         </div>
         <div className="nav-item">
           <NavLink
             activeclassname="active"
             className="project-link"
             to="/project"
           >
             <FontAwesomeIcon icon={faProjectDiagram} color="#4d4d4e" />
           </NavLink>
           <div className="horizontal-line" />
         </div>
         <div className="nav-item">
           <NavLink
             activeclassname="active"
             className="contact-link"
             to="/contact"
           >
             <FontAwesomeIcon icon={faContactCard} color="#4d4d4e" />
           </NavLink>
         </div>
       </nav>
       <ul>
         <li>
           <a
             className="svg-B"
             href={profile.linkedin}
             target="_blank"
             rel="noreferrer"
           >
             <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
           </a>
         </li>
         <li>
           <a
             className="svg-B"
             href={profile.github}
             target="_blank"
             rel="noreferrer"
           >
             <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
           </a>
         </li>
         <li>
           <a
             className="svg-B"
             href={profile.leetcode}
             rel="noreferrer"
             target="_blank"
             aria-label="LeetCode"
             title="LeetCode"
            >
             <FontAwesomeIcon icon={faCode} color="#4d4d4e" />
            </a>
         </li>
         <li>
           <a
             className="svg-B"
             href={profile.resume}
             rel="noreferrer"
             target="_blank"
             aria-label="Resume"
             title="Resume"
           >
             <FontAwesomeIcon icon={faFileLines} color="#4d4d4e" />
           </a>
         </li>
       </ul>
     </div>
   );
}

export default Sidebar